import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import CustomStepper from '../components/common/CustomStepper';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

type OrderCheckoutStepperProps = {
  handleBack: () => void;
  activeStep: number;
  showSubtitle?: boolean;
};

export default function OrderCheckoutStepperWrapper({ handleBack, activeStep }: OrderCheckoutStepperProps) {
  const { theme } = useThemeContext();

  const renderTitleStepper = () => {
    return (
      <>
        <Box sx={{ mb: 3 }}>
          <Link to="" onClick={handleBack} style={{ color: theme.custom.orderPFAS.stepper.backLinkColor, textDecoration: 'none' }}>
            {'<'} Back
          </Link>
        </Box>
      </>
    );
  };

  return (
    <Box sx={{ mb: 3, mt: 3, padding: '0 28px' }}>
      {renderTitleStepper()}
      <CustomStepper steps={4} activeStep={activeStep}></CustomStepper>
    </Box>
  );
}
